export default "__VITE_ASSET__CHgh_948__"